"use client"

import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "../../lib/utils"

// Colors are painted via the --ac-* CSS variables rather than Tailwind color
// utilities: the VTT app has no Tailwind theme registration for ac-mint/ac-dark
// (those tokens live in tokens.css), so classes like `bg-ac-mint` / `border-3`
// resolve to nothing here and the slider rendered colorless. Geometry classes
// (sizes, rounded, transition) are core Tailwind utilities and still apply.
const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center py-2",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className="relative h-2 w-full grow overflow-hidden rounded-full"
      style={{
        background: "hsl(var(--ac-dark-secondary))",
        border: "1px solid hsl(var(--ac-dark-accent))",
        boxShadow: "inset 0 1px 2px hsl(var(--ac-surface-0) / 0.6)",
      }}
    >
      <SliderPrimitive.Range
        className="absolute h-full rounded-full"
        style={{ background: "hsl(var(--ac-mint-primary))" }}
      />
    </SliderPrimitive.Track>
    {props.value?.map((_, index) => (
      <SliderPrimitive.Thumb
        key={index}
        className="ac-slider-thumb block h-5 w-5 rounded-full shadow-lg transition-all disabled:pointer-events-none disabled:opacity-50 hover:scale-110 hover:shadow-xl cursor-grab active:cursor-grabbing active:scale-105"
        style={{
          background: "hsl(var(--ac-mint-primary))",
          border: "2px solid hsl(var(--ac-dark-primary))",
        }}
      />
    )) || (
      <SliderPrimitive.Thumb
        className="ac-slider-thumb block h-6 w-6 rounded-full shadow-lg transition-all disabled:pointer-events-none disabled:opacity-50 hover:scale-110 hover:shadow-xl cursor-grab active:cursor-grabbing active:scale-105"
        style={{
          background: "white",
          border: "2px solid hsl(var(--ac-mint-primary))",
        }}
      />
    )}
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
